import React from "react";
import ReactSelectInput from "../../Components/Inputs/ReactSelectInput";
import ReactSelectAsync from "../../Components/Inputs/ReactSelectAsync";
import DateInput from "../../Components/Inputs/DateInput";

export default function ({errors, control, register, data, searchProduct}) {
  return (
    <>
      <ReactSelectInput
        label="Shop (filter)"
        name="shop_id"
        className="col-md-12 col-sm-6 pt-3"
        options={data?.shops}
        control={control}
        errorMessage={errors?.shop_id}
      />

      <ReactSelectAsync
        label="Product"
        name="product_id"
        placeholder="Choose Products"
        className="col-md-12 col-sm-6"
        inputClassName="col-12 mt-3"
        options={data?.products}
        errorMessage={errors?.product_id}
        control={control}
        search={searchProduct}
      />

      <DateInput
        label="Start Date"
        name="date_from"
        parentClasses="col-md-6 mt-4"
        register={register}
        errorMessage={errors?.date_from}
      />

      <DateInput
        label="End date"
        name="date_to"
        parentClasses="col-md-6 mt-4"
        register={register}
        errorMessage={errors?.date_to}
      />
    </>
  );
}